'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ReactIcons = require('components/Common/ReactIcons');

var _Common = require('components/Common');

var _Icons = require('components/Common/Icons');

var _projectDragItemTypes = require('../projectDragItemTypes');

var _projectDragItemTypes2 = _interopRequireDefault(_projectDragItemTypes);

var _reactDnd = require('react-dnd');

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./NodeViewContent.pcss');

var shallowEqualCustomizer = function shallowEqualCustomizer(value) {
  if (typeof value === 'function') return true;
};

var nodeSource = {
  beginDrag: function beginDrag(props) {
    var id = props.id;

    props.onBeginDragSubtree(id);
    return { id: id };
  },
  endDrag: function endDrag(props, monitor) {
    var _monitor$getDifferenc = monitor.getDifferenceFromInitialOffset();

    var dx = _monitor$getDifferenc.x;
    var dy = _monitor$getDifferenc.y;


    props.onEndDragSubtree({ dx: dx, dy: dy });

    return true;
  }
};

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
    draggedNode: monitor.getItem()
  };
}

var NodeDragHandle = (_dec = (0, _reactDnd.DragSource)(_projectDragItemTypes2.default.NODE_HANDLE, nodeSource, collectSource), _dec(_class = function (_Component) {
  _inherits(NodeDragHandle, _Component);

  function NodeDragHandle() {
    _classCallCheck(this, NodeDragHandle);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NodeDragHandle).apply(this, arguments));
  }

  _createClass(NodeDragHandle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.connectDragPreview((0, _reactDndHtml5Backend.getEmptyImage)(), { captureDraggingState: true }); // remove preview
    }
  }, {
    key: 'render',
    value: function render() {
      var connectDragSource = this.props.connectDragSource;


      return connectDragSource(_react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.dragHandle, styles.control) },
        _react2.default.createElement(
          'i',
          { className: styles.controlIcon },
          _react2.default.createElement(_ReactIcons.DragHandle, { hover: this.props.isDragging })
        )
      ));
    }
  }]);

  return NodeDragHandle;
}(_react.Component)) || _class);

var NodeViewContent = function (_Component2) {
  _inherits(NodeViewContent, _Component2);

  function NodeViewContent() {
    _classCallCheck(this, NodeViewContent);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NodeViewContent).apply(this, arguments));
  }

  _createClass(NodeViewContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _raf2.default)(this.sendBoundingRectUpdates.bind(this));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      // checks only for shallow equality of props and state
      return !(0, _shallowequal2.default)(nextProps, this.props, shallowEqualCustomizer);
    }
  }, {
    key: 'getNodeCaptionBoundingRect',
    value: function getNodeCaptionBoundingRect() {
      var captionNode = this.refs.captionNode;

      if (!captionNode) return { width: 0, height: 0 };

      return {
        width: captionNode.offsetWidth + 16 * 2,
        height: captionNode.offsetHeight
      };
    }
  }, {
    key: 'startEdit',
    value: function startEdit() {
      this.refs.captionTextArea.startEdit();
    }
  }, {
    key: 'sendBoundingRectUpdates',
    value: function sendBoundingRectUpdates() {
      if (!this.props.onBoundingRectUpdated) return;

      var rect = this.getNodeCaptionBoundingRect();
      var width = rect.width;
      var height = rect.height;


      this.props.onBoundingRectUpdated({ width: width, height: height });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(nextProps) {
      if (nextProps.caption !== this.props.caption) {
        this.sendBoundingRectUpdates();
      }
    }
  }, {
    key: 'handleCaptionEditChange',
    value: function handleCaptionEditChange() {
      var _this3 = this;

      setTimeout(function () {
        return _this3.sendBoundingRectUpdates();
      }, 0);
    }
  }, {
    key: 'handleMenuClick',
    value: function handleMenuClick(ev) {
      ev.stopPropagation();
      this.props.onMenuOpen();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var caption = _props.caption;
      var color = _props.color;
      var nodeOver = _props.nodeOver;
      var canBeDropTarget = _props.canBeDropTarget;
      var expanded = _props.expanded;
      var menuOpen = _props.menuOpen;
      var dragging = _props.dragging;
      var editingCaption = _props.editingCaption;
      var highlightColor = _props.highlightColor;
      var light = _props.light;
      var connectDragSource = _props.connectDragSource;
      var disableModifications = _props.disableModifications;


      var classname = (0, _classnames2.default)(styles.nodeView, disableModifications && styles.disableModifications, nodeOver && styles.nodeOver, expanded && styles.expanded, menuOpen && styles.menuOpen, dragging && styles.dragging, editingCaption && styles.editingCaption, highlightColor && styles.highlightColor);

      var Content = _react2.default.createElement(
        'div',
        {
          className: classname,
          style: { backgroundColor: color, color: light ? 'black' : 'white' },
          onMouseEnter: this.props.onMouseEnter,
          onMouseMove: this.props.onMouseEnter,
          onMouseLeave: this.props.onMouseLeave
        },
        _react2.default.createElement(NodeDragHandle, this.props),
        _react2.default.createElement(
          'div',
          {
            ref: 'captionNode',
            className: styles.caption,
            onClick: this.props.onClick
          },
          _react2.default.createElement(_Common.EditableTextArea, {
            ref: 'captionTextArea',
            disabled: disableModifications,
            dark: !light, maxWidth: 300, text: caption,
            editing: editingCaption,
            onEditSubmit: this.props.onCaptionEdit,
            onEditStart: this.props.onCaptionEditStart,
            onEditChange: this.handleCaptionEditChange.bind(this)
          })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.control },
          _react2.default.createElement(
            'i',
            { onClick: this.handleMenuClick.bind(this), className: styles.controlIcon },
            _react2.default.createElement(_ReactIcons.Hamburger, null)
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: styles.overlay,
            style: { borderColor: color }
          },
          canBeDropTarget ? _react2.default.createElement(_Icons.Clip, { className: styles.clipIcon }) : _react2.default.createElement(_Icons.ClipCrossed, { className: styles.clipIcon })
        )
      );

      return disableModifications ? Content : connectDragSource(Content);
    }
  }]);

  return NodeViewContent;
}(_react.Component);

exports.default = NodeViewContent;


NodeViewContent.propTypes = {
  id: _react.PropTypes.string.isRequired,
  color: _react.PropTypes.string.isRequired,
  caption: _react.PropTypes.string.isRequired,

  editingCaption: _react.PropTypes.bool,

  onMenuOpen: _react.PropTypes.func.isRequired,
  onBoundingRectUpdated: _react.PropTypes.func.isRequired,

  onCaptionEditStart: _react.PropTypes.func.isRequired,
  onCaptionEdit: _react.PropTypes.func.isRequired,

  onMouseEnter: _react.PropTypes.func.isRequired,
  onMouseLeave: _react.PropTypes.func.isRequired,
  onClick: _react.PropTypes.func.isRequired,

  connectDragSource: _react.PropTypes.func.isRequired,
  disableModifications: _react.PropTypes.bool
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/NodeView/NodeViewContent.js
// module id = 596
// module chunks = 1